export default [
  'none',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
  '0px 3px 5px -2px rgba(0, 0, 0, 0.2)',
];
